define('glu/defaultStrings',[],function() {
    'use strict';

    return {
        addColumns: 'Add columns',
        addFilter: 'Add filter',
        addAnotherFilter: 'Add another filter',
        advanced: 'Advanced',
        advancedSearch: 'Advanced search',
        'advancedSearch.apply.changes': 'Apply changes',
        'advancedSearch.cancel': 'Cancel',
        afterCutoff: 'Invalid date - after cutoff',
        anErrorOccurredMsg: 'An error occurred while processing your request. Please contact your local administrator.',
        anErrorOccurredTitle: 'An error occurred',
        apply: 'Apply',
        blockedDate: 'Invalid date - blocked',
        cancel: 'Cancel',
        clear: 'Clear',
        clearAll: 'Clear All',
        clearSourceSelection: 'Clear selection',
        clearTargetSelection: 'Clear selection',
        configure: 'Configure',
        dailyLimit: 'Daily view limited to 1 year',
        dateRequired: 'Date required',
        day: 'Day',
        defaultResultsName: 'records',
        details: 'Details',
        display: 'Display',
        done: 'Done',
        entireTable: 'Entire table',
        filter: 'Filter',
        gridNotProvideFilteringMsg: 'Grid does not support filtering and no collection was provided.',
        historyLimit: 'History is limited to 7 years',
        iE7Error: 'This application cannot be started in Internet Explorer 7 or below.',
        ifSelectedNotAvailableNextDayWillBeUsed: 'If the selected date is not available, the next day will be used.',
        invalidDateFormat: 'Invalid date format',
        invalidDateRange: 'Start date must be before end date',
        jumpToLastPage: 'Jump to last page',
        lastPage: 'Last Page',
        loading: 'Loading...',
        loadingUiComponent: 'Loading UI Component',
        manage: 'Manage',
        manageColumns: 'Manage columns',
        moveAllItems: 'Move all items',
        moveSelectedItems: 'Move selected items',
        multiSortTitle: 'Intelligent Sort',
        nextPage: 'Next Page',
        no: 'No',
        number: 'number',
        of: 'of',
        ofTheMonth: 'of the month',
        ok: 'OK',
        onThe: 'On the',
        page: 'Page',
        pagination: 'Pagination',
        perPage: 'per page',
        previousPage: 'Previous Page',
        records: 'records',
        recordsPerPage: 'records per page',
        remove: 'Remove',
        removeAllItems: 'Remove all items',
        removeColumn: 'Remove column',
        removeColumnMsg: 'Removing this column will also remove the associated Filter Criteria.',
        removeConfirmTitle: 'Confirm Remove',
        removeSelectedItems: 'Remove selected items',
        save: 'Save',
        searchField: 'Search field',
        searchValue: 'Search value',
        selectAll: 'Select all',
        selected: 'Selected',
        selectFields: 'Select fields',
        selectOneOrMoreDaysSchedulerMonthly: 'Select one or more days. Click again to deselect.',
        shouldBeANumber: 'Entered value should be a number.',
        showAllColumns: 'Show all columns',
        sourceListHeader: 'Available items',
        targetListHeader: 'Selected items',
        thereIsNoContent: 'No {0} found',
        thereIsNoTableCaption: 'There is no table caption',
        tooFarFuture: 'The date selected is too far in the future',
        tooFarPast: 'The date selected is before the first allowed date',
        'validator.beginsWith': '<%= description %> must start with <%= beginsWith %>',
        'validator.contains': '<%= description %> must contain <%= contains %>',
        'validator.emailAddress': '<%= description %> must be a valid email address',
        'validator.endsWith': '<%= description %> must end with <%= endsWith %>',
        'validator.equalTo': '<%= description %> must be equal to <%= equalTo %>',
        'validator.exists': '<%= description %> is required',
        'validator.isEmailAddress': '<%= description %> must be a valid email address',
        'validator.isGreaterThan': '<%= description %> must be greater than <%= isGreaterThan %>',
        'validator.isLessThan': '<%= description %> must be less than <%= isLessThan %>',
        'validator.isNumeric': '<%= description %> must be a number',
        'validator.isUnique': '<%= description %> must have a unique value',
        'validator.matches': '<%= description %> must match our requirements',
        'validator.matchesDatePattern': '<%= description %> must be a valid date',
        'validator.maxLength': '<%= description %> must be less than <%= maxLength %> characters long',
        'validator.maxValue': '<%= description %> must be no more than <%= maxValue  %>',
        'validator.minLength': '<%= description %> must be at least <%= minLength %> characters',
        'validator.minValue': '<%= description %> must be at least <%= minValue  %>',
        'validator.notSameValue': '<%= description %> should not match <%= notSameValue %>',
        'validator.oneOf': '<%= description %> must be one of <%= oneOf %>',
        'validator.range': '<%= description %> must be between <%= range[0] %> and <%= range[1] %>',
        'validator.rangeLength': '<%= description %> must be between <%= rangeLength[0] %> and <%= rangeLength[1] %> characters long',
        'validator.sameValue': '<%= description %> does not match <%= sameValue %>',
        'validator.us10DigitPhone': '<%= description %> must be a valid 10 digit US phone number',
        'validator.usZipCode': '<%= description %> must be a valid zip or zip+4 code',
        'scheduler.forExample': 'For example:',
        'scheduler.minutes': 'Minute(s)',
        'scheduler.hours': 'Hour(s)',
        'scheduler.day': 'Day',
        'scheduler.weeks': 'Week(s)',
        'scheduler.months': 'Month(s)',
        'scheduler.years': 'Year(s)',
        'scheduler.repeatEvery': 'Repeat every',
        'scheduler.startDate': 'Start Date',
        'scheduler.endDate': 'End Date',
        notCurrentlyDisplayed: 'Not currently displayed',
        manageFilters: 'Manage filters',
        viewing: 'Viewing',
        yes: 'Yes',
        clearFilters: 'Clear filters',
        clearFilter: 'Clear filter',
        update: 'Update',
        selectAllRows: 'Select all rows',
        selectView: 'Select view',
        savedViews: 'Saved views',
        saveThisView: 'Save this view',
        makeDefault: 'Make default',
        'default': 'Default',
        removeSavedView: 'Remove saved view',
        removeSavedViewMsg: 'Are you sure you want to delete saved view "{0}"?',
        makeDefaultSavedView: 'Make default saved view',
        makeDefaultSavedViewMsg: 'Are you sure you want to make default saved view "{0}"?',
        savedViewName: 'Saved view name',
        'filter.equal': 'is equal to',
        'filter.less': 'is less than',
        'filter.less.or.equal': 'is less than or equal to',
        'filter.greater': 'is greater than',
        'filter.greater.or.equal': 'is greater than or equal to',
        'filter.between': 'is between'
    };
});

